// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__BJXxW","paginator":"styles_paginator__TrlWI"};